import React from 'react'
import Select, { components } from 'react-select'
import './styles/styles.css'
import { useSelector } from 'react-redux'

// import { s } from 'react-dom-factories'
// import 'react-select/dist/react-select.css'

const ValueContainer = ({ children, getValue, ...props }) => {
  var values = getValue()
  var valueLabel = ''

  if (values.length > 0)
    valueLabel += props.selectProps.getOptionLabel(values[0])
  if (values.length > 1)
    valueLabel = valueLabel.slice(0, 6) + `... (${values.length - 1}) more`

  // Keep standard placeholder and input from react-select
  var childsToRender = React.Children.toArray(children).filter(
    (child) =>
      ['Input', 'DummyInput', 'Placeholder'].indexOf(child.type.name) >= 0
  )

  return (
    <components.ValueContainer {...props}>
      {!props.selectProps.inputValue && valueLabel}
      {childsToRender}
    </components.ValueContainer>
  )
}
//eslint-disable-next-line
export default (props) => {
  const languageRedux = useSelector((state) => state.language?.language?.data)
  const language = languageRedux || {}

  const optionsSelect =
    props.options &&
    props.options.map((option, index) => {
      return {
        value: option.name,
        label: option.name,
        isDisabled: option.isDisabled,
        option,
      }
    })

  let selectedOptions = null

  if (
    (props.placeholder === 'Select Filters' ||
      // props.placeholder === 'Select Group' ||
      props.placeholder === 'Select Curriculum' ||
      props.placeholder === 'Select Language' ||
      props.placeholder ===
        (language.settings ? language.settings.categories : 'Categories') ||
      props.placeholder === 'Divisions') &&
    // ||
    // props.placeholder === 'Escojer Grupo'
    props.selectedOptions
  ) {
    selectedOptions = {
      ...props.selectedOptions,
      value: props.selectedOptions.name,
      label: props.selectedOptions.name,
    }
  } else if (props.placeholder === 'Select Job Role') {
    selectedOptions = {
      ...props.selectedOptions,
      value: props.selectedOptions
        ? props.selectedOptions.value
        : 'Select Job Role',
      label: props.selectedOptions
        ? props.selectedOptions.value
        : 'Select Job Role',
    }
  } else if (
    props.placeholder ===
    (language.manager_report
      ? language.manager_report.select_role
      : 'Select Role')
  ) {
    selectedOptions =
      props.selectedOptions &&
      props.selectedOptions.map((option) => {
        return {
          value: option.hasOwnProperty('option')
            ? option.option.name
            : option.name,
          label: option.hasOwnProperty('option')
            ? option.option.name
            : option.name,
          name: option.hasOwnProperty('option')
            ? option.option.name
            : option.name,
          option: option.hasOwnProperty('option') ? option.option : option,
        }
      })
  } else if (
    (props.placeholder ===
      (language.manager_report
        ? language.manager_report.select_location
        : 'Select Location') ||
      props.placeholder ===
        (language.general ? language.general.select_tags : 'Select Tags') ||
      props.placeholder ===
        (language.manager_report
          ? language.manager_report.select_group
          : 'Select Group') ||
      props.placeholder === 'Select course' ||
      props.placeholder === 'Escojer Grupo' ||
      props.placeholder === 'Escojer Localidad') &&
    props.selectedOptions
  ) {
    selectedOptions =
      props.selectedOptions &&
      props.selectedOptions.map((option) => {
        return {
          value: option.name,
          label: option.name,
          name: option.name,
          option,
        }
      })
  } else if (
    props.placeholder === 'Add equivalent group' &&
    props.selectedOptions
  ) {
    console.log('leart118', props.selectedOptions)

    const group =
      props && props.options.find((group) => group.id === props.selectedOptions)

    selectedOptions = {
      ...props.selectedOptions,
      value: group && group.name,
      label: group && group.name,
    }
  } else if (
    props.placeholder === 'Add equivalent course' &&
    props.selectedOptions
  ) {
    const course =
      props &&
      props.options &&
      props.options.find((course) => course.id === props.selectedOptions)

    selectedOptions = {
      ...props.selectedOptions,
      value: course && course.name,
      label: course && course.name,
    }
  }

  if (props.placeholder === 'Select Language' && props.selectedOptions) {
    let lang
    if (props.selectedOptions.name) {
      lang = props.selectedOptions
    } else {
      lang =
        props &&
        props.options &&
        props.options.find((lang) => lang.id === props.selectedOptions)
    }

    selectedOptions = {
      ...props.selectedOptions,
      value: lang && lang.name,
      label: lang && lang.name,
    }
  }

  if (
    (props.placeholder === 'Course Type' ||
      props.placeholder === 'Tipo de Curso') &&
    props.selectedOptions.length > 0
  ) {
    let courseType

    let type = props.selectedOptions.map((option) => option.value)

    courseType = props.options.filter((course) => type.includes(course.value))

    selectedOptions =
      courseType &&
      courseType.map((option) => {
        return {
          value: option.name,
          label: option.name,
          name: option.name,
          option,
        }
      })
  }

  if (
    (props.placeholder === 'Employment Status' ||
      props.placeholder === 'Estatus de Empleo') &&
    props.selectedOptions.length > 0
  ) {
    let statusNum

    let statusType

    statusNum = props.selectedOptions.map((number) => number.option.status)

    statusType = props.options.filter((option) =>
      statusNum.includes(option.status)
    )

    selectedOptions =
      statusType &&
      statusType.map((option) => {
        return {
          value: option.name,
          label: option.name,
          name: option.name,
          option,
        }
      })
  }

  if (
    (props.placeholder === 'Active/Inactive' ||
      props.placeholder === 'Activo/Inactivo') &&
    props.selectedOptions
  ) {
    selectedOptions = {
      ...props.selectedOptions,
      value: props && props.selectedOptions,
      label: props && props.selectedOptions,
    }
  }

  return (
    <Select
      isMulti={props.multi !== undefined ? props.multi : true}
      value={selectedOptions}
      onChange={props.onChange}
      options={optionsSelect}
      valueKey={props.valueKey || 'name'}
      labelKey={props.labelKey || 'name'}
      selectAll={props.multi !== undefined ? props.multi : true}
      placeholder={props.placeholder || <div>Not selected</div>}
      isDisabled={props.isDisabled}
      language={props.language}
      components={
        (props.placeholder === 'Select Location' ||
          props.placeholder ===
            (language.manager_report
              ? language.manager_report.select_role
              : 'Select Role') ||
          props.placeholder === 'Employment Status' ||
          props.placeholder === 'Course Type' ||
          props.placeholder === 'Estatus de Empleo' ||
          props.placeholder === 'Tipo de Curso') && {
          ValueContainer,
        }
      }
      hideSelectedOptions={false}
      isClearable={true}
      menuPosition='fixed'
      menuPortalTarget={document.body}
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        control: (provided) => ({
          ...provided,
          height: props.height ?? 'default',
        }),
      }}
    />
  )
}

export const LanguageSelect = (props) => {
  const optionsSelect =
    props.options &&
    props.options.map((option, index) => {
      return {
        value: option.name,
        label: option.name,
        option,
      }
    })
  let language = props.language || {}

  let selectedOptions = null

  props.selectedOptions && Array.isArray(props.selectedOptions)
    ? (selectedOptions =
        props.selectedOptions &&
        props.selectedOptions.map((option) => {
          return {
            value: option.name,
            label: option.name,
            name: option.name,
            option,
          }
        }))
    : (selectedOptions = {
        ...props.selectedOptions,
        value: props.selectedOptions.name,
        label: props.selectedOptions.name,
      })

  // Remove the X in the add language selector
  const MultiValueRemove = () => {
    return (
      <components.MultiValueRemove {...props}>
        <span style={{ display: `none` }}></span>
      </components.MultiValueRemove>
    )
  }

  return (
    <Select
      components={{ MultiValueRemove }}
      isMulti={props.multi !== undefined ? props.multi : true}
      name='form-field-name'
      value={selectedOptions}
      onChange={props.onChange}
      valueKey={props.valueKey || 'name'}
      labelKey={props.labelKey || 'name'}
      options={optionsSelect}
      placeholder={
        props.placeholder ||
        (language.general ? language.general.not_selected : null)
      }
      isDisabled={props.isDisabled}
      clearable={false}
      escapeClearsValue={false}
      backspaceToRemoveMessage=''
      searchable={false}
      backspaceRemoves={false}
      deleteRemoves={false}
      language={props.language}
      menuPosition='fixed'
      menuPortalTarget={document.body}
      styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
    />
  )
}
